import api from 'services/api';

export const getAuthTokenService = async () => {
  try {
    return await api.get('/auth/token/');
  } catch (e) {
    throw e;
  }
};

export const deleteAuthTokenService = async () => {
  try {
    return await api.delete('/auth/token/');
  } catch (e) {
    throw e;
  }
};

export const resendEmailConfirmationService = async (email, company) => {
  try {
    return await api.post('/auth/signup/resend-email/', { email, company });
  } catch (e) {
    throw e;
  }
};

export const verifyEmailService = async key => {
  try {
    return await api.post('/auth/signup/verify-email/', { key });
  } catch (e) {
    throw e;
  }
};
